<template>
  <div
    v-show="!isBroadcast || broadcastTeacher"
    @click="toggleReverseTimeDisplay()"
    class="runtime text-white text-xs-center">
    <span class="branding-inactive-text">{{ (isReversedTimeToggled) ? `-${reversedRuntime}` : runtime }}</span>
    <br />
    <span class="branding-inactive-text" style="opacity: 0.7">{{duration}}</span>
  </div>
</template>

<script>

import {
  mapGetters,
} from 'vuex';

export default {
  name: 'time-display',
  data() {
    return {
      isReversedTimeToggled: false,
    }
  },
  computed: {
    ...mapGetters('player', [
      'runtime',
      'duration',
      'reversedRuntime',
			'isBroadcast',
			'broadcastTeacher',
    ]),
  },
  methods: {
    toggleReverseTimeDisplay() {
      this.isReversedTimeToggled = !this.isReversedTimeToggled;
    }
  }
};

</script>

<style lang="scss" scoped>

.runtime {
  position: absolute;
  bottom: 60px;
  text-align: center;
  width: 100%;
  cursor: pointer;
}

.runtime i {
  font-size: 2.5em;
}

</style>
